<div class="forgot-password">
  <ion-grid>
    <ion-row class="forgot-password__row">
      <ion-col class="forgot-password__col" size="12">
        @if(!showSuccess) {
        <ion-card class="forgot-password__card">
          <ng-container>
            <app-card-header-title-subtitle
              title="forgot-password.title"
              subtitle="forgot-password.subtitle"
            />

            @if (error) {
            <app-general-error [code]="error" />
            }

            <ion-card-content class="ion-no-padding">
              <form
                class="forgot-password__form"
                [formGroup]="forgotPassForm"
                novalidate
                (submit)="submitForm()"
              >
                <ion-row class="ion-justify-content-center">
                  <ion-col size="12">
                    <app-input
                      [formGroup]="forgotPassForm"
                      label="login.email"
                      formControlName="email"
                      maxlength="50"
                      type="email"
                      [required]="true"
                    />
                  </ion-col>
                </ion-row>
                <ion-row class="ion-justify-content-center">
                  <ion-col size="12">
                  </ion-col>
                </ion-row>
                <ion-row class="forgot-password__buttons">
                  <ion-col class="pl-0" size="12" sizeMd="6">
                    <a
                      (click)="handleRedirect()"
                      state="{ blockRouting: true }"
                      class="m-0 button-link button-link-outline"
                    >
                      {{ 'forgot-password.btn-back' | translate }}
                    </a>
                  </ion-col>
                  <ion-col class="pr-0" size="12" sizeMd="6">
                    <ion-button
                      #button
                      class="ion-float-right button-solid m-0"
                      expand="block"
                      type="submit"
                      [disabled]="!forgotPassForm.valid"
                    >
                      {{ 'forgot-password.btn-accept' | translate }}
                    </ion-button>
                  </ion-col>
                </ion-row>
              </form>
            </ion-card-content>
          </ng-container>
        </ion-card>
        } @else {
        <app-auth-verification-handler
          view="forgot-password"
          process="passSuccess"
          (goBackClicked)="goBackFromVerification($event)"
        />
        }
      </ion-col>
    </ion-row>
  </ion-grid>
</div>
